import api from "./api"
import request from "@/util/request"
import ajax from "@/components/common/upload_utils/ajax.simple"
// 获取用户信息 TODO： 临时用的，后面可能用不到
function getUserInfo() {
  const url = api.userInfo
  return ajax({
    url,
    method: 'get',
  }).then(res => {
    if(res instanceof Array) {
      return res[0]
    }
    return res
  })
}

// 当前用户的会员身份以及相应特权详情
async function getMemberInfo() {
  const userInfo = await getUserInfo()
  const url = api.membershipDetail
  const { user_id } = userInfo
  const res = await request.get(url, {
    userId: user_id
  })
  const info = res.data
  return {
    vipLevelName: info.name,
    ...info,
    ...userInfo,
  }
}
// 获取所有等级的会员的特权列表
function getAllLevelPrivilege() {
  const url = api.membershipGroupInfo
  return request.get(url).then(res => {
    const { code, data } = res
    if(code === 0) {
      return data
    }
    return []
  })
}
// 生成订单
function generatorOrder({userId, priceId}) {
  const url = api.orderCreate
  return request.post(url, {
    source: "default",
    userId,
    priceId,
    type: 1, //备用，1 纯粹购买，2 升级
  }).then(res => {
    if(res.code === 0) {
      return res.data
    }
  })
}
// 生成支付二维码
function generatorWxQRUrl({ userId, orderNo, payment = 'NATIVE' }) {
  const url = api.wechatPay
  return request.post(url, {
    code: '',
    userId,
    // order_no: orderNo,
    orderNo,
    payment,
  }).then(res => {
    if(res.code === 0) {
      return res.data
    }
    return {}
  })
}
// 查询订单支付情况
function checkOrderHasPaid({ userId, orderNo, payType }) {
  const url = api.orderCheck
  return request.post(url, {
    userId,
    // order_no: orderNo,
    orderNo,
    payType,
    payment: "NATIVE",
  }).then(res => {
    const { code, data } = res
    if(code === 0) {
      return data.status
    }
  })
}
// 支付成功查询订单结果详情
function checkOrderDetail({ userId, orderNo }) {
  const url = api.orderDetail
  return request.get(url, {
    userId,
    order_no: orderNo,
  }).then(res => {
    const { code, data } = res
    if(code === 0) {
      return data
    }
  })
}

export {
  getMemberInfo, getAllLevelPrivilege,
  generatorOrder, generatorWxQRUrl, checkOrderHasPaid, checkOrderDetail,
  
}